import { Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop.js";
import AboutScreen from "./screen/AboutScreen/AboutScreen.js";
import ContactScreen from "./screen/ContactScreen/ContactScreen.js";
import Home from "./screen/Home/Home.js";
import RoomDetailScreen from "./screen/RoomDetailScreen/RoomDetailScreen.js";
import RoomScreen from "./screen/RoomScreen/RoomScreen.js";
import SustainabilityScreen from "./screen/SustainabilityScreen/SustainabilityScreen.js";

function App() {
  return (
    <div>
      <ScrollToTop />
      {/* <Layout /> */}
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="odalar" exact element={<RoomScreen />} />
        <Route path="oda-detay" exact element={<RoomDetailScreen />} />
        <Route path="iletisim" exact element={<ContactScreen />} />
        <Route path="hakkimizda" exact element={<AboutScreen />} />
        <Route path="surdurulebilirlik" exact element={<SustainabilityScreen />} />
      </Routes>
    </div>
  );
}

export default App;
